<!-- 绑定银行卡 -->
<template>
  <div class="content-box" id="change-pwd">
    <!-- header start -->
    <van-nav-bar
      :title="typeName == 'add' ? '绑定银行卡' : '修改银行卡'"
      fixed
      :placeholder="true"
      :z-index="99"
      left-arrow
      @click-left="goBack"
    />
    <!-- header end -->

    <div v-if="model != null">
      <van-cell-group>
        <van-field
          v-model="model.IdCard"
          label="身份证号"
          placeholder="输入身份证号"
        />
        <van-field
          v-model="model.CollectionAccount"
          label="持卡人姓名"
          placeholder="如：张三"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="model.CollectionBrankName"
          label="开户银行"
          placeholder="请输入开户行"
        />
        <van-field
          v-model="model.CollectionNumber"
          type="number"
          label="银行卡号"
          placeholder="请输入卡号"
        />
      </van-cell-group>
    </div>
    <div v-else>
      <van-cell-group>
        <van-field
          v-model="IdCard"
          label="身份证号"
          placeholder="输入身份证号"
        />
        <van-field
          v-model="CollectionAccount"
          label="持卡人姓名"
          placeholder="如：张三"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="CollectionBrankName"
          label="开户银行"
          placeholder="请输入开户行"
        />
        <van-field
          v-model="CollectionNumber"
          type="number"
          label="银行卡号"
          placeholder="请输入卡号"
        />
      </van-cell-group>
    </div>
    <div
      class="change-btn"
      @click="bindBankCard()"
      tapmode
      v-if="typeName == 'add'"
    >
      立即绑定
    </div>
    <div
      class="change-btn"
      @click="updateBankCard()"
      tapmode
      v-if="typeName == 'edit'"
    >
      立即修改
    </div>

    <div class="blank-remark" >
      备注：
      开户银行请填写准确到地方的支行 <br/>
      例如：中国银行-广东省深圳市南山区***支行
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  data() {
    return {
      IdCard: "",
      CollectionAccount: "",
      CollectionBrankName: "",
      CollectionNumber: "",
      typeName: this.$route.query.typeName,
      model: this.$route.query.model,
      id: 0,
    };
  },
  components: {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    bindBankCard() {
      var _this = this;
      this.$store
        .dispatch({
          type: "UpdateMemberBankInfo",
          idCard: this.IdCard,
          collectionAccount: this.CollectionAccount,
          collectionBrankName: this.CollectionBrankName,
          collectionNumber: this.CollectionNumber,
        })
        .then((res) => {
          if (res.Result.IsSuccess) {
            Toast(res.Result.Message);
            _this.$router.go(-1);
          } else {
            Toast(res.Result.Message);
          }
        });
    },
    updateBankCard() {
      var _this = this;
      this.$store
        .dispatch({
          type: "UpdateMemberBankInfo",
          serialNumber: this.model.SerialNumber,
          idCard: this.model.IdCard,
          collectionAccount: this.model.CollectionAccount,
          collectionBrankName: this.model.CollectionBrankName,
          collectionNumber: this.model.CollectionNumber,
        })
        .then((res) => {
          if (res.Result.IsSuccess) {
            Toast(res.Result.Message);
            _this.$router.go(-1);
          } else {
            Toast(res.Result.Message);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.blank-remark{
  padding: 15px;
  color: red;
  font-size: 15px;
}

</style>
